const OktaClientId = process.env.REACT_APP_OKTA_CLIENT_ID;
const OktaDomain = process.env.REACT_APP_OKTA_DOMAIN;
const OktaIssuer = process.env.REACT_APP_OKTA_ISSUER;

export const OKTA_CONFIG = {
  issuer: OktaIssuer,
  domain: OktaDomain,
  clientId: OktaClientId,
  redirectUri: `${window.location.origin}/authentication/login`,
  scopes: ['profile', 'openid', 'email'],
  tokenManager: {
    storage: 'sessionStorage',
  },
};
